import { ASSET_PATHS } from "./assets";
import { all_links } from "./links";

export const PricingTable = () => {
    const pricingData = [
    {
      product: "Popular Captcha",
      icon: ASSET_PATHS.pricing_logos.popular,
      type: "Image Recognition",
      price: "0.15",
      speed: "< 1s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.popular
    },
    {
      product: "BLS Captcha",
      icon: ASSET_PATHS.pricing_logos.bls,
      type: "Image Recognition",
      price: "0.15",
      speed: "< 1s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.bls
    },
    {
      product: "reCAPTCHA V2",
      icon: ASSET_PATHS.pricing_logos.recaptcha,
      type: "Image Recognition",
      price: "0.14",
      speed: "< 2s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.recaptcha
    },
    {
      product: "AWS WAF",
      icon: ASSET_PATHS.pricing_logos.aws,
      type: "Image Recognition",
      price: "0.15",
      speed: "< 2s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.aws
    },
    {
      product: "Geetest V4",
      icon: ASSET_PATHS.pricing_logos.geetest,
      type: "Image Recognition",
      price: "0.45",
      speed: "< 3s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.geetest4
    },
    {
      product: "Geetest V4",
      icon: ASSET_PATHS.pricing_logos.geetest,
      type: "Token-Based",
      price: "0.50",
      speed: "< 3s",
      unit: "/1000 reqs",
      tag: "New",
      api: all_links.pricing_api_links.geetest4_new
    },
    {
      product: "Geetest V3",
      icon:ASSET_PATHS.pricing_logos.geetest,
      type: "Image Recognition",
      price: "0.15",
      speed: "< 3s",
      unit: "/1000 reqs",
      tag: "New",
      api: all_links.pricing_api_links.geetest3
    },
    {
      product: "ImageToText",
      icon: ASSET_PATHS.pricing_logos.imagetotext,
      type: "Standard OCR",
      price: "0.15",
      speed: "< 0.5s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.imagetotext
    },
    {
      product: "MtCaptcha",
      icon: ASSET_PATHS.pricing_logos.mtcaptcha,
      type: "Token-Based",
      price: "0.15",
      speed: "< 2s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.mtcaptcha
    },
    {
      product: "Prosopo",
      icon: ASSET_PATHS.pricing_logos.prosopo,
      type: "Image Recognition",
      price: "0.15",
      speed: "< 1s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.prosopo
    },
    {
      product: "TikTok Captcha",
      icon: ASSET_PATHS.pricing_logos.tiktok,
      type: "Image Recognition",
      price: "0.15",
      speed: "< 1.5s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.tiktok
    },
    {
      product: "CaptchaFox",
      icon: ASSET_PATHS.pricing_logos.captchafox,
      type: "Image Recognition",
      price: "0.15",
      speed: "< 1s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.captchafox
    },
    {
      product: "Cloudflare Turnstile",
      icon: ASSET_PATHS.pricing_logos.cloudflare,
      type: "Token-Based",
      price: "0.50",
      speed: "< 0.5s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.cloudflareTurnstile
    },
    {
      product: "Cloudflare Challenge",
      icon: ASSET_PATHS.pricing_logos.cloudflare,
      type: "Token-Based",
      price: "1.00",
      speed: "~ 5s",
      unit: "/1000 reqs",
      api: all_links.pricing_api_links.cloudflareChallenge
    }
  ];

  return (
    <section id="pricing" className="py-20 md:py-28 relative bg-gradient-to-br from-[#000000] via-[#0a0424] to-[#0f0527]">
      {/* Background ambient glow */}
      <div className="absolute inset-x-0 top-1/3 h-96 bg-gradient-to-t from-black/50 to-transparent blur-3xl z-0"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="font-pixel text-4xl sm:text-5xl md:text-6xl text-white text-center mb-12 md:mb-20 drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]">
          "Transparent Pricing, Unbeatable Speed"
        </h2>
        
        {/* --- STRETCHED & MORE APPEALING TABLE --- */}
        <div className="text-white font-kodeMono w-full max-w-7xl mx-auto border border-white/20 p-2 rounded-2xl bg-black/40 backdrop-blur-lg shadow-2xl shadow-blue-500/10">
          
          {/* --- UPGRADED HEADER --- */}
          <div className="grid grid-cols-12 bg-slate-900/50 border-b-2 border-slate-700 text-slate-300 rounded-t-lg px-4 md:px-6 py-4 font-bold text-sm sm:text-base tracking-wider uppercase">
            <div className="col-span-4 pl-2">Service</div>
            <div className="col-span-2">Type</div>
            <div className="col-span-2 text-center">Cost</div>
            <div className="col-span-2 text-center">Speed</div>
            <div className="col-span-2 text-right pr-2">API Docs</div>
          </div>
          
          {/* --- LARGER, SPACED-OUT ROWS --- */}
          {pricingData.map((item, index) => (
            <div 
              key={index} 
              className="group transition-all duration-300 ease-in-out border-b border-slate-800/70 last:border-b-0"
            >
              <div 
                className="grid grid-cols-12 items-center 
                           bg-transparent group-hover:bg-slate-800/40 
                           text-gray-300 group-hover:text-white 
                           px-4 md:px-6 py-5 md:py-6 text-sm sm:text-base 
                           transition-all duration-300 
                           transform group-hover:scale-[1.02]"
              >
                {/* Product Name & Icon */}
                <div className="col-span-4 flex items-center gap-4">
                  {item.icon && (
                    <div className="flex-shrink-0 w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center p-1.5 border border-white/10 shadow-md">
                      <img 
                        src={item.icon}
                        alt={`${item.product} icon`}
                        className="w-full h-full object-contain"
                        onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.classList.add('hidden'); }}
                      />
                    </div>
                  )}
                  <div className="flex flex-col">
                    <span className="font-bold text-base md:text-lg text-white">{item.product}</span>
                    {item.tag && (
                      <span className="text-xs text-pink-400 mt-1 animate-pulse group-hover:animate-none">{item.tag}</span>
                    )}
                  </div>
                </div>

                {/* Type */}
                <div className="col-span-2 flex items-center">
                  <span className="text-slate-400">{item.type}</span>
                </div>

                {/* Cost */}
                <div className="col-span-2 flex items-center justify-center">
                  <span className="font-bold text-lg text-white">
                    ${item.price}
                    <span className="text-sm text-slate-400 ml-1.5">{item.unit}</span>
                  </span>
                </div>

                {/* Speed */}
                <div className="col-span-2 flex items-center justify-center">
                  <span className={`px-2.5 py-1.5 rounded-md text-sm font-semibold ${
                    item.speed.includes('< 1s') ? 'bg-green-500/10 text-green-300 border border-green-400/20' :
                    item.speed.includes('< 2s') ? 'bg-blue-500/10 text-blue-300 border border-blue-400/20' :
                    'bg-purple-500/10 text-purple-300 border border-purple-400/20'
                  }`}>
                    {item.speed}
                  </span>
                </div>

                {/* API Button */}
                <div className="col-span-2 flex items-center justify-end">
                  <a 
                    href={item.api} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-lg bg-slate-700/50 px-4 py-2 text-sm text-slate-200 hover:bg-slate-600/80 transition-all border border-slate-600 shadow-sm transform hover:scale-105"
                  >
                    <span>API</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
